import { render, staticRenderFns } from "./duty.vue?vue&type=template&id=a1b488e2&scoped=true"
import script from "./duty.vue?vue&type=script&lang=js"
export * from "./duty.vue?vue&type=script&lang=js"
import style0 from "./duty.vue?vue&type=style&index=0&id=a1b488e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b488e2",
  null
  
)

export default component.exports